// dynamic-import.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DynamicImportService {
  async loadStylesheet(url: string): Promise<void> {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const styleElement = document.createElement('style');
      styleElement.innerHTML = await response.text();
      document.head.appendChild(styleElement);
    } catch (error) {
      console.error('Failed to load stylesheet:', error);
    }
  }
}
